<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="2 2 20 20">
    <path d="M5,9l1.41,1.41L11,5.83V22H13V5.83l4.59,4.59L19,9l-7-7L5,9z" />
  </svg>
</template>
<style lang="scss" scoped>
@use "@/assets/styles/settings/_variables.scss";
svg {
  height: 1em;
  fill: currentColor;
}
</style>
